<template>
  <div class="flex w-full justify-center px-4 xl:px-6">
    <div class="grid w-full max-w-960 grid-cols-12 gap-x-6 gap-y-0">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
